import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from "@Common/widgets/flex-layout/flex-layout.module";
import {MatAngularModule} from "@Common/mat-angular.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {GestionRoutingModule} from "./gestion-routing";
import {AccueilGestionComponent} from "./accueil/accueil.component";
import {FormBuilderModule} from "../common/components/form";
import {FormulairesListeComponent} from './formulaires-liste/formulaires-liste.component';
import {EditFormulaireComponent} from './formulaires-liste/edit-formulaire/edit-formulaire.component';
import {CommonModuleP8} from "@Common/common-p8.module";
import {RenduFormulaireComponent} from './formulaires-liste/rendu-formulaire/rendu-formulaire.component';
import {ReponsesComponent} from './reponses/reponses.component';
import {ReponseFicheComponent} from './reponses/reponse-fiche/reponse-fiche.component';
import {GestionnairesFormulaireComponent} from './formulaires-liste/gestionnaires-formulaire/gestionnaires-formulaire.component';
import { GestionnairesListComponent } from './formulaires-liste/gestionnaires-formulaire/gestionnaires-list/gestionnaires-list.component';
import { ListHomeComponent } from './reponses/list-home/list-home.component';
import { ModaleResponseComponent } from './reponses/modale-response/modale-response.component';
import { FilterSelectionComponent } from './reponses/filters/filter-fields-custom-selection/filter-selection.component';
import { FilterTypeValueComponent } from './reponses/filters/filter-fields-custom-selection/filter-type-value/filter-type-value.component';
import { FilterCustomEnabledComponent } from './reponses/filters/filter-fields-custom-selection/filter-enabled/filter-custom-enabled.component';
import { FilterFieldsResponseSelectionComponent } from './reponses/filters/filter-fields-response-selection/filter-fields-response-selection.component';
import { FilterTypeComponent } from './reponses/filters/filter-fields-response-selection/filter-type/filter-type.component';
import {FilterResponseEnabledComponent} from './reponses/filters/filter-fields-response-selection/filter-enabled/filter-response-enabled.component';
import { ContainerResponseComponent } from './reponses/container-response/container-response.component';
import { ModaleRenduFormulaireComponent } from './formulaires-liste/rendu-formulaire/modale-rendu-formulaire-container/modale-rendu-formulaire.component';
import {ModalLinkFormComponent} from './url-form/modal-link-form/modal-link-form.component';
import {UrlFormComponent} from './url-form/url-form/url-form.component';
import {UrlListComponent} from './url-form/url-list/url-list.component';
import {UrlEditComponent} from './url-form/url-edit/url-edit.component';
import {ModalUrlEditComponent} from './url-form/url-edit/url-edit-modale/modal-url-edit.component';
import { FormulairesArchivedComponent } from './formulaires-archived/formulaires-archived.component';
import {ClipboardModule} from '@angular/cdk/clipboard';
import { AccueilReponsesComponent } from './demandes/accueil-reponses.component';
import { FormulairesDemandesListeComponent } from './demandes/formulaires-demandes-liste/formulaires-demandes-liste.component';
import { BlocResponseStatusComponent } from './demandes/formulaires-demandes-liste/bloc-status/bloc-response-status.component';
import { ResponsesStatusSummaryComponent } from './demandes/formulaires-demandes-liste/responses-status-summary/responses-status-summary.component';
import { SearchDemandesResultsComponent } from './demandes/search-demandes-results/search-demandes-results.component';
import { DownloadPdfComponent } from './reponses/download-pdf/download-pdf.component';
import { RequestOpinionComponent } from './reponses/reponse-fiche/request-opinion/request-opinion.component';
import { ListOpinionsComponent } from './reponses/reponse-fiche/list-opinions/list-opinions.component';
import { ConsultOpinionComponent } from './reponses/reponse-fiche/list-opinions/consult-opinion/consult-opinion.component';
import { OpinionComponent } from './reponses/opinion/opinion.component';
import { AvisFicheComponent } from './reponses/reponse-fiche/avis-fiche/avis-fiche.component';
import { AvisResponseValuesComponent } from './reponses/reponse-fiche/avis-fiche/avis-response-values/avis-response-values.component';
import {CommonDematModule} from '../common/common.module';
import { RequestersListFormComponent } from './formulaires-liste/requesters-list-form/requesters-list-form.component';
import { RequestersFormComponent } from './formulaires-liste/requesters-list-form/requesters-form/requesters-form.component';
import { RequestersListFormEditComponent } from './formulaires-liste/requesters-list-form/requesters-list-form-edit/requesters-list-form-edit.component';
import { RequesterEditComponent } from './formulaires-liste/requesters-list-form/requesters-list-form-edit/requester-edit/requester-edit.component';
import { RequestOpinionByListComponent } from './reponses/reponse-fiche/request-opinion-by-list/request-opinion-by-list.component';
import {ImagepdfviewerModule} from "@Common/widgets/general/imagepdfviewer";
import {DialogFileComponent} from "./reponses/file-preview/dialog-file/dialog-file.component";
import {PreviewFileComponent} from "./reponses/file-preview/preview-file/preview-file.component";
import { SimpleReponseFicheComponent } from './reponses/reponse-fiche/simple-reponse-fiche/simple-reponse-fiche.component';
import { OpinionsVisualizeComponent } from './reponses/opinions-visualize/opinions-visualize.component';

@NgModule({
    declarations: [
        AccueilGestionComponent,
        FormulairesListeComponent,
        EditFormulaireComponent,
        RenduFormulaireComponent,
        ReponsesComponent,
        ReponseFicheComponent,
        GestionnairesFormulaireComponent,
        GestionnairesListComponent,
        ListHomeComponent,
        ModaleResponseComponent,
        FilterSelectionComponent,
        FilterTypeValueComponent,
        FilterCustomEnabledComponent,
        FilterFieldsResponseSelectionComponent,
        FilterTypeComponent,
        FilterResponseEnabledComponent,
        ContainerResponseComponent,
        ModaleRenduFormulaireComponent,
        ModalLinkFormComponent,
        UrlFormComponent,
        UrlListComponent,
        UrlEditComponent,
        ModalUrlEditComponent,
        FormulairesArchivedComponent,
        AccueilReponsesComponent,
        FormulairesDemandesListeComponent,
        BlocResponseStatusComponent,
        ResponsesStatusSummaryComponent,
        SearchDemandesResultsComponent,
        DownloadPdfComponent,
        RequestOpinionComponent,
        ListOpinionsComponent,
        ConsultOpinionComponent,
        OpinionComponent,
        AvisFicheComponent,
        AvisResponseValuesComponent,
        RequestersListFormComponent,
        RequestersFormComponent,
        RequestersListFormEditComponent,
        RequesterEditComponent,
        RequestOpinionByListComponent,
        DialogFileComponent,
        PreviewFileComponent,
        SimpleReponseFicheComponent,
        OpinionsVisualizeComponent,
    ],
    imports: [
        FlexLayoutModule,
        MatAngularModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        GestionRoutingModule,
        FormBuilderModule,
        CommonModuleP8,
        ClipboardModule,
        CommonDematModule,
        ImagepdfviewerModule,
    ],
  exports: [
    ReponseFicheComponent,
    OpinionsVisualizeComponent
  ]
})
export class GestionModule {
}
